import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ProfileService } from '../../../services/profile.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-connections-box',
  templateUrl: './connections-box.component.html',
  styleUrls: ['./connections-box.component.scss']
})
export class ConnectionsBoxComponent implements OnInit {
    userConnections: any[] = [];
    public headerBtn = false;
    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) { }

    ngOnInit(): void {
        this.getUserConnections(1);
    }
    getUserConnections(page: any) {
        this.profileService.getUserConnections(this.authentication._authentication.id, page).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {
                        for (var i = 0; i < res.data.length; i++) {
                            if (res.data[i].isActive) {
                                //res.data[i].contactLogo = "url('" + res.data[i].contactLogo + "')";
                                let newTitleArr: any[] = [];

                                res.data[i].title = res.data[i].title.trim();
                                res.data[i].portalAccount.name = res.data[i].portalAccount.name.trim();
                                newTitleArr.push(res.data[i].title);
                                newTitleArr.push(res.data[i].portalAccount.name);
                                res.data[i].newTitle = newTitleArr.join(' , ');
                                this.userConnections.push(res.data[i]);
                            }
                        }
                    }
                }
                else {
                    console.error("Web/ConnectionsBox", res.error_message);
                }



                //this.userConnections = res['myConnection'];
            },
            (err: any) => {
                console.error("getUserConnections", err);
            });
    }


    openConnection() {
        this.router.navigate(['/profile/connections']);

    }
    openUserProfile(profileUserId: any) {
        this.router.navigate(['/profile/user-profile/' + profileUserId]);
    }

}
